import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import { api } from "@/lib/api";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import Booking from "@/pages/Booking";
import BookingConfirmed from "@/pages/BookingConfirmed";
import ManageBooking from "@/pages/ManageBooking";
import PayBooking from "@/pages/PayBooking";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Flyers from "@/pages/Flyers";
import LeaveReview from "@/pages/LeaveReview";
import GiftSession from "@/pages/GiftSession";
import GiftStatus from "@/pages/GiftStatus";
import GiftCard from "@/pages/GiftCard";
import AskDrGadget from "@/pages/AskDrGadget";
import TicketStatus from "@/pages/TicketStatus";
import AdminLogin from "@/pages/AdminLogin";
import AdminCallback from "@/pages/AdminCallback";
import AdminDashboard from "@/pages/AdminDashboard";
import About from "@/pages/About";
import Project from "@/pages/Project";
import Membership from "@/pages/Membership";
import MembershipStatus from "@/pages/MembershipStatus";
import SignAgreement from "@/pages/SignAgreement";
import TechPortal from "@/pages/TechPortal";
import "@/App.css";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AdminCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/project/:id" element={<Project />} />
        <Route path="/book" element={<Booking />} />
        <Route path="/book/confirmed/:token" element={<BookingConfirmed />} />
        <Route path="/book/manage/:token" element={<ManageBooking />} />
        <Route path="/pay/success" element={<PaymentSuccess />} />
        <Route path="/pay/:token" element={<PayBooking />} />
        <Route path="/flyers" element={<Flyers />} />
        <Route path="/review" element={<LeaveReview />} />
        <Route path="/gift" element={<GiftSession />} />
        <Route path="/gift/card/:token" element={<GiftCard />} />
        <Route path="/gift/:token" element={<GiftStatus />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/membership/:token" element={<MembershipStatus />} />
        <Route path="/sign/:token" element={<SignAgreement />} />
        <Route path="/tech" element={<TechPortal />} />
        <Route path="/ask" element={<AskDrGadget />} />
        <Route path="/ticket/:token" element={<TicketStatus />} />
        <Route path="/about" element={<About />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminGate><AdminDashboard /></AdminGate>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

function AdminGate({ children }) {
  const [state, setState] = useState({ loading: true, ok: false });
  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me").then((r) => {
      setState({ loading: false, ok: !!r.data?.is_admin });
    }).catch(() => setState({ loading: false, ok: false }));
  }, []);
  if (state.loading) {
    return <div className="min-h-[60vh] flex items-center justify-center text-slate-400">Checking access…</div>;
  }
  if (!state.ok) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors theme="dark" />
      <AppRouter />
    </BrowserRouter>
  );
}
